(function() {
  'use strict';
  
  angular
    .module('plugins.free-text-response', ['app.plugins', 'app.data'])
    .config(config);
    
  
  config.$inject = ['pluginsProvider', 'PLUGIN'];
  
  function config(pluginsProvider, PLUGIN) {
    
    pluginsProvider.register(PLUGIN.POLL_TYPE, 'free-text-response', {icon: 'font_download'});
    pluginsProvider.register(PLUGIN.RESULT_TYPE, 'free-text-response', true);
    pluginsProvider.register(PLUGIN.RESULT_EXPORTERS, 'free-text-response', {
      weight: -1,
      formats: [
        {
          name: 'Free Text Responses',
          extension: '.csv',
          factory: 'FreeTextResponseResultExportCsv'
        }
      ]
    });
  }
  
})();